import React, { useState, useRef, useEffect } from "react";
import { RiEqualizerLine } from "react-icons/ri";
import "./FilterBy.css";

type FilterByProps = {
  options: string[];
  heading: string;
  value?: string;
  onFilterChange: (selected: string) => void;
};

const FilterBy: React.FC<FilterByProps> = ({
  options,
  onFilterChange,
  heading,
  value,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedFilter = value || options[0];

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="filter-container" ref={dropdownRef} onClick={toggleDropdown}>
      <span className="filter-label">{heading}</span>
      <div className="custom-dropdown">
        <span className="selected-option">{selectedFilter}</span>
        <RiEqualizerLine className="filter-icon" />
        {isOpen && (
          <ul className="FilterBar-dropdown-menu">
            {options.map((option) => (
              <li
                key={option}
                className={`FilterBar-dropdown-item ${
                  selectedFilter === option ? "active" : ""
                }`}
                onClick={() => {
                  onFilterChange(option);
                  setIsOpen(false);
                }}
              >
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FilterBy;
